"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTime = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.rule)({
    ...nano_theme_1.lightTheme.font.ui1.mid,
    d: 'inline-flex',
    ai: 'baseline',
    gap: '6px',
    ws: 'nowrap',
});
const dateClass = (0, nano_theme_1.drule)({
    fz: '13px',
    lh: '18px',
});
const timeClass = (0, nano_theme_1.drule)({
    ...nano_theme_1.lightTheme.font.mono.mid,
    fz: '12px',
    lh: '18px',
    letterSpacing: '0.01em',
});
const sepClass = (0, nano_theme_1.drule)({
    d: 'inline-block',
    w: '3px',
    h: '3px',
    bdrad: '50%',
    alignSelf: 'center',
});
const toDate = (value) => {
    if (value instanceof Date)
        return value;
    return new Date(value);
};
const DateTime = ({ value, timeOnly, dateOnly, seconds, long, locale, className, style, }) => {
    const styles = (0, context_1.useStyles)();
    const date = toDate(value);
    const time = date.getTime();
    // biome-ignore lint/correctness/useExhaustiveDependencies: depend on the timestamp, not the Date instance, to avoid recomputing for equivalent dates
    const dateLabel = React.useMemo(() => {
        if (timeOnly)
            return '';
        return new Intl.DateTimeFormat(locale, {
            day: 'numeric',
            month: long ? 'long' : 'short',
            year: 'numeric',
        }).format(date);
    }, [time, timeOnly, long, locale]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: depend on the timestamp, not the Date instance, to avoid recomputing for equivalent dates
    const timeLabel = React.useMemo(() => {
        if (dateOnly)
            return '';
        return new Intl.DateTimeFormat(locale, {
            hour: '2-digit',
            minute: '2-digit',
            second: seconds ? '2-digit' : undefined,
            hour12: false,
        }).format(date);
    }, [time, dateOnly, seconds, locale]);
    const iso = date.toISOString();
    return (React.createElement("span", { className: blockClass + (className ? ` ${className}` : ''), style: style, title: iso, "data-iso": iso },
        !timeOnly && React.createElement("span", { className: dateClass({ col: styles.g(0.2) }) }, dateLabel),
        !timeOnly && !dateOnly && React.createElement("span", { className: sepClass({ bg: styles.g(0, 0.25) }), "aria-hidden": "true" }),
        !dateOnly && React.createElement("span", { className: timeClass({ col: styles.g(0.5) }) }, timeLabel)));
};
exports.DateTime = DateTime;
